var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.proceed.apply(null, arguments)
        },
        keydown: function($event) {
          return _vm.vehicleForm.errors.clear($event.target.name)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "row" }, [
                _vm.userRole != "user"
                  ? _c("div", { staticClass: "col-xl-12 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Tax Payer")
                          ]),
                          _vm._v(" "),
                          _c("v-select", {
                            class: {
                              "form-control is-invalid": _vm.vehicleForm.errors.has(
                                "user_id"
                              )
                            },
                            attrs: {
                              options: _vm.users,
                              reduce: function(name) {
                                return name.id
                              },
                              label: "name",
                              name: "user_id"
                            },
                            model: {
                              value: _vm.vehicleForm.user_id,
                              callback: function($$v) {
                                _vm.$set(_vm.vehicleForm, "user_id", $$v)
                              },
                              expression: "vehicleForm.user_id"
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "user_id"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans("vehicle_registration.product_type_id")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        class: {
                          "form-control is-invalid": _vm.vehicleForm.errors.has(
                            "product_type_id"
                          )
                        },
                        attrs: {
                          options: Object.entries(_vm.productTypes).map(
                            function(ref) {
                              var id = ref[0]
                              var name = ref[1]

                              return { id: parseInt(id), name: name }
                            }
                          ),
                          reduce: function(option) {
                            return option.id
                          },
                          label: "name"
                        },
                        model: {
                          value: _vm.vehicleForm.product_type_id,
                          callback: function($$v) {
                            _vm.$set(_vm.vehicleForm, "product_type_id", $$v)
                          },
                          expression: "vehicleForm.product_type_id"
                        }
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.vehicleForm,
                          "prop-name": "product_type_id"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans("vehicle_registration.vehicle_type_id")
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        class: {
                          "form-control is-invalid": _vm.vehicleForm.errors.has(
                            "vehicle_type_id"
                          )
                        },
                        attrs: {
                          options: Object.entries(_vm.vehicleTypes).map(
                            function(ref) {
                              var id = ref[0]
                              var name = ref[1]

                              return { id: parseInt(id), name: name }
                            }
                          ),
                          reduce: function(option) {
                            return option.id
                          },
                          label: "name"
                        },
                        model: {
                          value: _vm.vehicleForm.vehicle_type_id,
                          callback: function($$v) {
                            _vm.$set(_vm.vehicleForm, "vehicle_type_id", $$v)
                          },
                          expression: "vehicleForm.vehicle_type_id"
                        }
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.vehicleForm,
                          "prop-name": "vehicle_type_id"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.trans(
                              "vehicle_registration.vehicle_category_id"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("v-select", {
                        class: {
                          "form-control is-invalid": _vm.vehicleForm.errors.has(
                            "vehicle_category_id"
                          )
                        },
                        attrs: {
                          options: Object.entries(_vm.vehicleCategories).map(
                            function(ref) {
                              var id = ref[0]
                              var name = ref[1]

                              return { id: parseInt(id), name: name }
                            }
                          ),
                          reduce: function(option) {
                            return option.id
                          },
                          label: "name"
                        },
                        model: {
                          value: _vm.vehicleForm.vehicle_category_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.vehicleForm,
                              "vehicle_category_id",
                              $$v
                            )
                          },
                          expression: "vehicleForm.vehicle_category_id"
                        }
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.vehicleForm,
                          "prop-name": "vehicle_category_id"
                        }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xl-12 col-md-12 col-12" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Vehicle Information")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("vehicle_registration.make"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.make,
                                expression: "vehicleForm.make"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has("make")
                            },
                            attrs: {
                              type: "text",
                              name: "make",
                              placeholder: _vm.trans(
                                "vehicle_registration.make"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.make },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "make",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "make"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("vehicle_registration.model"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.model,
                                expression: "vehicleForm.model"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has("model")
                            },
                            attrs: {
                              type: "text",
                              name: "model",
                              placeholder: _vm.trans(
                                "vehicle_registration.model"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.model },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "model",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "model"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.year_of_manufacture"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.vehicleForm.year_of_manufacture,
                                  expression: "vehicleForm.year_of_manufacture"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "year_of_manufacture"
                                )
                              },
                              attrs: { name: "year_of_manufacture" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "year_of_manufacture",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans(
                                      "vehicle_registration.year_of_manufacture"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.years(), function(year) {
                                return _c(
                                  "option",
                                  { domProps: { value: year } },
                                  [_vm._v(_vm._s(year))]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "year_of_manufacture"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("vehicle_registration.color"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.vehicleForm.color,
                                  expression: "vehicleForm.color"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "color"
                                )
                              },
                              attrs: { name: "color" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "color",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("vehicle_registration.color")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.colors, function(color) {
                                return _c(
                                  "option",
                                  { domProps: { value: color.id } },
                                  [_vm._v(_vm._s(color.name))]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "color"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.engine_capacity"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.vehicleForm.engine_capacity,
                                  expression: "vehicleForm.engine_capacity"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "engine_capacity"
                                )
                              },
                              attrs: { name: "engine_capacity" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "engine_capacity",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "1.0 - 1.6" } }, [
                                _vm._v("1.0 - 1.6")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "1.6 - 2.6" } }, [
                                _vm._v("1.6 - 2.6")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "3.1 - 4.0" } }, [
                                _vm._v("3.1 - 4.0")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "engine_capacity"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.engine_number")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.engine_number,
                                expression: "vehicleForm.engine_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "engine_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "engine_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.engine_number"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.engine_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "engine_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "engine_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-6 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.policy_number")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.policy_number,
                                expression: "vehicleForm.policy_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "policy_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "policy_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.policy_number"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.policy_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "policy_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "policy_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-6 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.chasis_number")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.chasis_number,
                                expression: "vehicleForm.chasis_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "chasis_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "chasis_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.chasis_number"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.chasis_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "chasis_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "chasis_number"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xl-12 col-md-12 col-12" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Owner's Information")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xl-3 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(_vm.trans("vehicle_registration.id_type"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.vehicleForm.id_type,
                                  expression: "vehicleForm.id_type"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "id_type"
                                )
                              },
                              attrs: { name: "id_type" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "id_type",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one")))
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "national_id" } },
                                [_vm._v("National ID")]
                              ),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "voter_card" } }, [
                                _vm._v("Voter's Card")
                              ]),
                              _vm._v(" "),
                              _c(
                                "option",
                                { attrs: { value: "international_passport" } },
                                [_vm._v("International Passport")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "id_type"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-3 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.id_number")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.id_number,
                                expression: "vehicleForm.id_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "id_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "id_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.id_number"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.id_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "id_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "id_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-3 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.drivers_license_number"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.drivers_license_number,
                                expression: "vehicleForm.drivers_license_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "drivers_license_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "drivers_license_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.drivers_license_number"
                              )
                            },
                            domProps: {
                              value: _vm.vehicleForm.drivers_license_number
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "drivers_license_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "drivers_license_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-3 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.license_bearer_number"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.license_bearer_number,
                                expression: "vehicleForm.license_bearer_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "license_bearer_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "license_bearer_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.license_bearer_number"
                              )
                            },
                            domProps: {
                              value: _vm.vehicleForm.license_bearer_number
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "license_bearer_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "license_bearer_number"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xl-12 col-md-12 col-12" }, [
                  _c("h4", { staticClass: "card-title" }, [
                    _vm._v("Plate Information")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.plate_number")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.plate_number,
                                expression: "vehicleForm.plate_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "plate_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "plate_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.plate_number"
                              )
                            },
                            domProps: { value: _vm.vehicleForm.plate_number },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "plate_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "plate_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.plate_number_state_code"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.vehicleForm.plate_number_state_code,
                                  expression:
                                    "vehicleForm.plate_number_state_code"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "plate_number_state_code"
                                )
                              },
                              attrs: { name: "plate_number_state_code" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "plate_number_state_code",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "Sokoto" } }, [
                                _vm._v("Sokoto")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "plate_number_state_code"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-4 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.plate_number_lga_code"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.vehicleForm.plate_number_lga_code,
                                  expression:
                                    "vehicleForm.plate_number_lga_code"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.vehicleForm.errors.has(
                                  "plate_number_lga_code"
                                )
                              },
                              attrs: { name: "plate_number_lga_code" },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.vehicleForm,
                                    "plate_number_lga_code",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v(_vm._s(_vm.trans("general.select_one")))
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "BIN" } }, [
                                _vm._v("BIN")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "BOD" } }, [
                                _vm._v("BOD")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "DAN" } }, [
                                _vm._v("DAN")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "GAD" } }, [
                                _vm._v("GAD")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "GOR" } }, [
                                _vm._v("GOR")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "GWD" } }, [
                                _vm._v("GWD")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "ILA" } }, [
                                _vm._v("ILA")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "ISA" } }, [
                                _vm._v("ISA")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "KER" } }, [
                                _vm._v("KER")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "KWN" } }, [
                                _vm._v("KWN")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "RAB" } }, [
                                _vm._v("RAB")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "SAB" } }, [
                                _vm._v("SAB")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "SHG" } }, [
                                _vm._v("SHG")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "SKK" } }, [
                                _vm._v("SKK")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "SKT" } }, [
                                _vm._v("SKT")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "SRZ" } }, [
                                _vm._v("SRZ")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "TAM" } }, [
                                _vm._v("TAM")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "TNG" } }, [
                                _vm._v("TNG")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "TBW" } }, [
                                _vm._v("TBW")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "WAM" } }, [
                                _vm._v("WAM")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "WRK" } }, [
                                _vm._v("WRK")
                              ]),
                              _vm._v(" "),
                              _c("option", { attrs: { value: "YAB" } }, [
                                _vm._v("YAB")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "plate_number_lga_code"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-6 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans(
                                  "vehicle_registration.old_plate_number"
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.vehicleForm.old_plate_number,
                                expression: "vehicleForm.old_plate_number"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "is-invalid": _vm.vehicleForm.errors.has(
                                "old_plate_number"
                              )
                            },
                            attrs: {
                              type: "text",
                              name: "old_plate_number",
                              placeholder: _vm.trans(
                                "vehicle_registration.old_plate_number"
                              )
                            },
                            domProps: {
                              value: _vm.vehicleForm.old_plate_number
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.vehicleForm,
                                  "old_plate_number",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "old_plate_number"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xl-6 col-md-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vehicle_registration.issue_date")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("datepicker", {
                            class: {
                              "form-control is-invalid": _vm.vehicleForm.errors.has(
                                "issue_date"
                              )
                            },
                            attrs: {
                              bootstrapStyling: true,
                              name: "issue_date"
                            },
                            on: {
                              selected: function($event) {
                                return _vm.vehicleForm.errors.clear(
                                  "issue_date"
                                )
                              }
                            },
                            model: {
                              value: _vm.vehicleForm.issue_date,
                              callback: function($$v) {
                                _vm.$set(_vm.vehicleForm, "issue_date", $$v)
                              },
                              expression: "vehicleForm.issue_date"
                            }
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.vehicleForm,
                              "prop-name": "issue_date"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-8 offset-md-4" },
          [
            _c(
              "button-spinner",
              {
                staticClass:
                  "btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right",
                staticStyle: { height: "39px", color: "#fff" },
                attrs: {
                  "is-loading": _vm.vehicleForm.isLoading,
                  disabled: _vm.vehicleForm.isLoading
                }
              },
              [
                _vm.id
                  ? _c("span", [_vm._v(_vm._s(_vm.trans("general.update")))])
                  : _c("span", [_vm._v(_vm._s(_vm.trans("general.save")))])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "btn btn-danger waves-effect waves-light pull-right mr-1 mb-1",
                attrs: { to: "/vehicle-registration" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.trans("general.cancel")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }